import { httpService } from '../http.service.js'

export const postService = {
  query,
  getById,
  save,
  remove,
  updateHelpful,
}

// שליפה של כל הפוסטים מהשרת
async function query(filterBy = {}) {
  try {
    const queryParams = new URLSearchParams(filterBy).toString()
    return await httpService.get(`post?${queryParams}`)
  } catch (err) {
    console.error('Failed to fetch posts:', err)
    throw err
  }
}

// שליפה של פוסט לפי מזהה ייחודי
async function getById(postId) {
  try {
    return await httpService.get(`post/${postId}`)
  } catch (err) {
    console.error(`Failed to get post with ID ${postId}:`, err)
    throw err
  }
}

// שמירה/עדכון של פוסט
async function save(post) {
  try {
    if (post._id) {
      // עדכון פוסט קיים
      return await httpService.put(`post/${post._id}`, post)
    } else {
      // יצירת פוסט חדש
      return await httpService.post('post', post)
    }
  } catch (err) {
    console.error('Failed to save post:', err)
    throw err
  }
}

// מחיקת פוסט
async function remove(postId) {
  try {
    return await httpService.delete(`post/${postId}`)
  } catch (err) {
    console.error(`Failed to remove post with ID ${postId}:`, err)
    throw err
  }
}

async function updateHelpful(postId, { type, userId }) {
  try {
    return await httpService.put(`post/${postId}/helpful`, { type, userId })
  } catch (err) {
    console.error('Failed to update helpful:', err)
    throw err
  }
}
